import { render, staticRenderFns } from "./AxFormErrors.vue?vue&type=template&id=6b92fa04&scoped=true&"
import script from "./AxFormErrors.vue?vue&type=script&lang=ts&"
export * from "./AxFormErrors.vue?vue&type=script&lang=ts&"
import style0 from "./AxFormErrors.vue?vue&type=style&index=0&id=6b92fa04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b92fa04",
  null
  
)

export default component.exports